export * from './potential.action';



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/actions/index.ts